import React from 'react';

import { Container } from './style.js';

export const Loader = () => (
  <>
    <Container>
      <div className="vertical-centered-box">
        <div className="content">
          <svg
            width="512"
            height="512"
            viewBox="0 0 512 512"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M422 0H90C40.2944 0 0 40.2944 0 90V422C0 471.706 40.2944 512 90 512H422C471.706 512 512 471.706 512 422V90C512 40.2944 471.706 0 422 0Z"
              fill="null"
            />
            <path
              d="M154.166 341.995V247.966C154.166 235.697 157.01 226.328 162.699 219.858C168.387 213.389 176.028 210.154 185.62 210.154C194.543 210.154 201.459 212.943 206.367 218.52C211.274 224.097 213.728 231.905 213.728 241.943V341.995H256.894V247.966C256.894 235.697 259.627 226.328 265.093 219.858C270.558 213.389 278.198 210.154 288.014 210.154C296.937 210.154 303.853 212.943 308.76 218.52C313.668 224.097 316.122 231.905 316.122 241.943V341.995H359.288V238.932C359.288 217.962 353.544 201.231 342.055 188.739C330.566 176.246 315.23 170 296.045 170C273.96 170 257.34 178.031 246.186 194.093C236.371 178.031 221.202 170 200.678 170C179.709 170 164.205 177.473 154.166 192.42V174.685H111V341.995H154.166Z"
              fill="#000"
            />
            <path
              d="M410.768 341.995C418.619 341.995 425.348 339.191 430.956 333.583C436.564 327.975 439.368 321.246 439.368 313.395C439.368 305.544 436.564 298.814 430.956 293.206C425.348 287.599 418.619 284.795 410.768 284.795C402.917 284.795 396.188 287.599 390.58 293.206C384.972 298.814 382.168 305.544 382.168 313.395C382.168 321.246 384.972 327.975 390.58 333.583C396.188 339.191 402.917 341.995 410.768 341.995Z"
              fill="#FFC400"
            />
          </svg>
          <div className="loader-circle"></div>
          <div className="loader-line-mask">
            <div className="loader-line"></div>
          </div>
        </div>
      </div>
    </Container>
  </>
);
